import React from "react";
import type { ReactNode } from "react";
import type { MortgageSearchParams } from "../Calculator/types";
import type { MortgageLeadFormProps } from "../LeadForm/MortgageLeadForm";
import { MortgageSmallCalculator } from "../SmallCalculator/MortgageSmallCalculator";

/**
 * @Shortcode
 *
 * @title "Szabad Felhasználású Lakáshitel kalkulátor"
 * @shortcode "free_use_mortgages_small"
 * @slug "szabadfelhasznalasu-lakashitel"
 * @type "calculator"
 */
export class FreeUseMortgageSmallCalculator extends React.PureComponent<MortgageLeadFormProps<MortgageSearchParams>> {
	public render(): ReactNode {
		return <MortgageSmallCalculator {...this.props} variant="freeUse" outsideTitle="Jelzáloghitel kalkulátor" />;
	}
}

export default FreeUseMortgageSmallCalculator;
